<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <h3 class="titles">订单详情</h3>
    <div class="content">
      <div class="top-center">
        <p v-if="order.length>0">订单编号：{{order[0].toi_sn}}</p>
        <p v-if="order.length>0">参观日期：{{order[0].t_date}} {{order[0].time_period}}</p>
      </div>
      <div class="inner">
        <div class="list" v-for="(item,index) in order" :key="index">
          <p class="list-title">
            {{item.toi_username}}
            <small>{{item.ticket_type}}</small>
          </p>
          <p>
            {{item.card_type}}
            {{item.toi_card_num}}
          </p>
          <p>
            {{item.ticket_name}}
            <span>
              ￥
              <span
                class="num"
              >{{item.ticket_name=="儿童乐园票"?Number(item.discount_price).toFixed(2):Number(item.ticket_price).toFixed(2)}}</span>
            </span>
          </p>
          <!-- <p>
            儿童乐园亲子票
            <span>
              ￥
              <span class="num">80.00</span>
            </span>
          </p>-->
        </div>
        <!-- <div class="list"> -->
        <!-- <p class="list-title">
            张三
            <small>学生票</small>
          </p>
          <p>
            身份证
            120120199912136666
        </p>-->
        <!-- <p>
            参观门票
            <span>
              ￥
              <span class="num">30.00</span>
            </span>
        </p>-->
        <!-- </div> -->
      </div>
    </div>
    <div class="bottom">
      <p>
        参观门票
        <span>
          ￥
          <span class="num">{{ticket_total.toFixed(2)}}</span>
        </span>
      </p>
      <p v-if="ticket_chid>0">
        儿童乐园门票
        <span>
          ￥
          <span class="num">{{ticket_chid.toFixed(2)}}</span>
        </span>
      </p>
      <p class="total">
        总计：
        <span>
          ￥
          <span class="num">{{total.toFixed(2)}}</span>
        </span>
      </p>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="mask" v-if="printF">
      <div class="mask-content">
        <div class="icon2"></div>
        <p>出票中，请稍后……</p>
      </div>
    </div>
    <div class="ok" @click="print_ticket">打印取票</div>
    <div class="back-btn" @click="goBack">返回</div>
    <div class="footer">
      <div class="footer-content">
        <p>
          <!-- 设备ID：{{deviceId}} -->
          <span class="tel">
            客服电话
            <span>25650850 25650860</span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      warn: "",
      printF: false,
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      timer: "",
      order: [],
      order_id: "",
      detail: "",
      titem_id: "",
      total: 0,
      ticket_chid: 0,
      ticket_total: 0,
      printFs: true
    };
  },
  mounted() {
    this.order = JSON.parse(localStorage.order);
    this.order_id = this.order.order_id;
    this.order.map((item, index) => {
      if (index == 0) {
        this.titem_id = item.titem_id;
      } else {
        this.titem_id = this.titem_id + "," + item.titem_id;
      }
      if (item.ticket_name != "儿童乐园票") {
        this.total += Number(item.ticket_price);
        this.ticket_total = Number(item.ticket_price);
      } else {
        this.total += Number(item.discount_price);
        this.ticket_chid = Number(item.discount_price);
      }
    });
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取订单信息
    print_ticket() {
      if (this.printFs) {
        this.printFs = false;
        this.printF = true;
        var that = this;
        this.$api.print_ticket(this.titem_id).then(ress => {
          var list = ress.data;
          list.map((item, index) => {
            if (index == 0) {
              this.strReturn =
                item.ticket_name +
                "," +
                item.ticket_type +
                // "," +
                // item.toi_username +
                "," +
                item.t_date +
                "," +
                item.time_period +
                "," +
                item.toi_sn_encode +
                "," +
                item.order_sn +
                ";";
            } else {
              this.strReturn +=
                item.ticket_name +
                "," +
                item.ticket_type +
                // "," +
                // item.toi_username +
                "," +
                item.t_date +
                "," +
                item.time_period +
                "," +
                item.toi_sn_encode +
                "," +
                item.order_sn +
                ";";
            }
          });
          if (ress.status == 1) {
            this.wran = "";
            var obj = jsObj.getPageStatus();
            var pageNum = obj.split(",")[1];
            if (Number(pageNum) >= list.length) {
              jsObj.PrintSellTicket("1", this.strReturn);
              var obj = jsObj.getPageStatus();
              var num2 = Number(obj.split(",")[1]);
              var num3 = Number(obj.split(",")[2]);
              var type = num2 < num3 ? 1 : 2;

              setTimeout(() => {
                this.printF = false;
                this.$router.push({
                  path: "/ticket_success",
                  query: {
                    t_date: that.order[0].t_date,
                    time_period: that.order[0].time_period,
                    order_id: this.order_id,
                    type: type
                  }
                });
              }, 2000);
            } else {
              this.warn = "纸张不足，请联系客服人员";
              setTimeout(() => {
                this.printF = false;
                this.warn = "";
                this.$router.replace("/nopage");
              }, 2000);
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
            this.printF = false;
          }
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.today = month + "月" + days + "日 " + strWeek;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    .icon2 {
      width: 97px;
      height: 104px;
      background: url(.././assets/print.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
.container {
  width: 100%;
  min-height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  position: relative;
  padding-bottom: 165px;
  .top {
    padding: 30px 32px;
    color: #4d4d4d;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    width: 100%;
    padding: 90px 50px 30px;
  }
}
.content {
  width: 972px;
  margin: 0 auto;
  min-height: 520px;
  border: 1px solid #1c78f7;
  border-radius: 14px;
  background: #fff;
  position: relative;
  &:after {
    content: "";
    width: 30px;
    height: 60px;
    border: 1px solid #1c78f7;
    background: #f0f0f0;
    position: absolute;
    top: 174px;
    left: -4px;
    border-radius: 0 30px 30px 0;
    border-left: 0 none;
  }
  &:before {
    content: "";
    width: 30px;
    height: 60px;
    border: 1px solid #1c78f7;
    background: #f0f0f0;
    position: absolute;
    top: 174px;
    right: -4px;
    border-radius: 30px 0px 0px 30px;
    border-right: 0 none;
  }
  .top-center {
    border-bottom: 1px dashed #1c78f7;
    font-size: 34px;
    color: #005192;
    padding: 57px 67px 50px;
    line-height: 50px;
  }
  .inner {
    padding: 0 65px;
    .list {
      border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
      padding: 43px 0;
      p {
        font-size: 35px;
        color: #353535;
        margin-bottom: 30px;
        overflow: hidden;
        span {
          float: right;
          display: inline-block;
          font-size: 24px;
          color: #e8593e;
          line-height: 34px;
          .num {
            font-size: 34px;
            font-weight: 600;
          }
        }
        &.list-title {
          font-size: 40px;
          small {
            font-size: 30px;
            color: rgba(0, 0, 0, 0.5);
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      &:last-child {
        border-bottom: 0 none;
        margin-bottom: 0;
      }
    }
  }
}
.bottom {
  margin: 52px auto;
  width: 850px;
  p {
    font-size: 35px;
    color: #353535;
    margin-bottom: 30px;
    overflow: hidden;
    span {
      float: right;
      display: inline-block;
      font-size: 24px;
      color: #e8593e;
      line-height: 34px;
      .num {
        font-size: 34px;
        font-weight: 600;
      }
    }
    &.total {
      font-size: 40px;
      text-align: right;
      line-height: 40px;
      span {
        line-height: 40px;
      }
    }
  }
}
.ok {
  width: 670px;
  height: 98px;
  line-height: 98px;
  text-align: center;
  font-size: 30px;
  letter-spacing: 3px;
  color: #fff;
  background: rgba(185, 80, 32, 1);
  border-radius: 49px;
  margin: 50px auto;
  cursor: pointer;
}
.back-btn {
  width: 670px;
  height: 98px;
  background: rgba(0, 81, 146, 0);
  border: 2px solid rgba(185, 80, 32, 1);
  border-radius: 49px;
  line-height: 98px;
  text-align: center;
  font-size: 30px;
  letter-spacing: 3px;
  color: rgba(185, 80, 32, 1);
  margin: 0 auto;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 24px;
  width: 100%;
  .footer-content {
    padding: 60px;
  }
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket_detail.vue